import { useEffect, useState } from 'react';

import plantService from '../services/plant';
import { HTTPError, Plant } from '../../../src/types';


const usePlants = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [plants, setPlants] = useState<Plant[]>([]);

    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                const plantsData = await plantService.getPlants();
                setPlants(plantsData)
            }
            catch (e) {
                setError((e as HTTPError).response.data['error']);
            }
            finally {
                setLoading(false);
            }
        })();
    }, [])
    return { plants, error, loading }
};

export default usePlants;
